<template>
  <transition
    enter-active-class="transition-opacity duration-200"
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="transition-opacity duration-200"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      v-if="visible"
      class="registration-blip absolute top-3 left-3 z-[10000] size-1.5 rounded-full select-none pointer-events-none"
      aria-live="polite"
      aria-label="Registration status received"
    />
  </transition>
</template>

<script lang="ts" setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import usePlayer from '@/composables/usePlayer'

const { state } = usePlayer()

const VISIBLE_DURATION_MS = 2000
const TICK_MS = 200

const nowMs = ref(Date.now())
let tickId: ReturnType<typeof setInterval> | null = null

const visible = computed(() => {
  if (state.tenant !== null) {
    return false
  }
  const receivedAt = state.registrationStatusReceivedAt
  if (receivedAt <= 0) {
    return false
  }
  return nowMs.value - receivedAt < VISIBLE_DURATION_MS
})

onMounted(() => {
  tickId = setInterval(() => {
    nowMs.value = Date.now()
  }, TICK_MS)
})

onBeforeUnmount(() => {
  if (tickId !== null) {
    clearInterval(tickId)
    tickId = null
  }
})
</script>

<style scoped>
/* Logo colors: cyan #22d3ee, magenta #e879f9 (AnimatedBackground / WaitingScreen) */
@keyframes registration-blip-color {
  0%,
  100% {
    background-color: rgba(34, 211, 238, 0.7);
    box-shadow: 0 0 8px rgba(34, 211, 238, 0.5);
  }
  50% {
    background-color: rgba(232, 121, 249, 0.7);
    box-shadow: 0 0 8px rgba(232, 121, 249, 0.5);
  }
}

/* Small duty cycle: bright for ~8% of the period, dim the rest */
@keyframes registration-blip-duty {
  0%,
  92%,
  100% {
    opacity: 0.2;
    transform: scale(0.85);
  }
  5%,
  87% {
    opacity: 1;
    transform: scale(1.2);
  }
}

.registration-blip {
  animation:
    registration-blip-color 1.8s ease-in-out infinite,
    registration-blip-duty 1.2s ease-in-out infinite;
}
</style>
